import React from 'react';

class ApertureGlazing extends React.Component {
  state = {
    panelOpen: false,
    step1: false,
    step2: false,
    step3: false,
    glazingOptions: [],
    activeAperture: null,
    selectGlazingId: null,
    selectGlazingName: null
  }

  componentDidMount() {
    // console.log(this.props.glazing)
  }
  updatedOptions = () => {
    // console.log(this.state.activeAperture, this.state.selectGlazingName);
    this.props.setAperture(this.state.activeAperture);
    this.props.setGlazing(this.state.selectGlazingName)
  }
  filterGlazing = () => {
    let glazingOptions = []
    Object.keys(this.props.glazing).forEach(key => {
      let value = this.props.glazing[key];
      if(value['go_aperture_code'] === this.state.activeAperture) {
        glazingOptions.push(value)
      }
    });
    this.setState({
      glazingOptions
    })
  }
  checkValues = () => {
    if(this.state.activeAperture === null && this.state.selectGlazingName === null) {
      this.setState({step3: false})
      this.updatedOptions()
    }
    this.props.checkCustomCode();
  }

  render() {
    return (
      <div className="aperture-and-glazing">
        {!this.state.step3 &&
        <div className="aperture-and-glazing-trigger" onClick={() => this.setState({panelOpen: true, step1: true})}>
          <div className="btn btn--block btn-chev-right">Add Aperture & Glazing</div>
        </div>
        }

        <div className={`aperture-and-glazing-panel ${this.state.panelOpen ? 'aperture-and-glazing-panel--active' : ''}`}>
          <div className="close-btn" onClick={() => this.setState({panelOpen: false, step1: false, step2: false})}>X</div>
          <div className="aperture-and-glazing__heading">
            Aperture & Glazing
          </div>
          {this.state.step1 && 
            <div className="aperture-options">
              <div className="aperture-and-glazing__title">
                1. Select your aperture
              </div>
              <div className="apertures">
              {this.props.apertures.map((aperture, index) => 
                <div key={index} className='aperture-wrapper'>
                  <div className={`aperture aperture-${aperture} ${this.state.activeAperture === aperture ? `aperture-${aperture}--active` : ''}`} onClick={() => this.setState({ activeAperture: aperture, selectGlazingId: null, selectGlazingName: null }, () => this.filterGlazing())}>
                  </div>
                  <span>{aperture}</span>
                </div>
                )}
              </div>
              {this.state.activeAperture && 
                <button className="btn" onClick={() => this.setState({step1: false, step2: true})}>Next: Choose Glazing</button>
              }
            </div>
          }

          {this.state.step2 && 
            <div className="glazing-options">
              <div className="aperture-and-glazing__title">
                2. Select your glazing
              </div>
              <div className="selected-aperture">
                <p>All glazing options for:</p>
                <div className={`aperture aperture-${this.state.activeAperture}`}>
                </div>
                <span>{this.state.activeAperture}</span>
              </div>
              <div className="glazings">
              {this.state.glazingOptions && 
              this.state.glazingOptions.map((glazing, index) => {
                return (<div key={glazing['gj_glazing_id']} className={`glazing ${this.state.selectGlazingId === glazing['gj_glazing_id'] ? `glazing--active` : ''}`} onClick={() => this.setState({selectGlazingId: glazing['gj_glazing_id'], selectGlazingName: glazing['go_glazing_name']})}><span></span>{glazing['go_glazing_name']}</div>)
              })}
              </div>
              <div className="button-group">
              <button className="btn" onClick={() => this.setState({step1: true, step2: false})}>Back</button>
              {this.state.selectGlazingId && 
                <button className="btn" onClick={() => this.setState({step1: false, step2: false, step3: true, panelOpen: false}, () => this.updatedOptions())}>Finish</button>
              }   
              </div>
            </div>
          }
        </div>
        {this.state.step3 &&
        <div className="aperture-and-glazing-finish" >
          <h3 onClick={() => this.setState({panelOpen: true, step1: true, step2: false})}>Edit Options</h3>
          {this.state.activeAperture &&
          <div className="selected-aperture">
            <div className={`aperture aperture-${this.state.activeAperture}`}></div>
            <span>{this.state.activeAperture}</span>
            <i className="fa fa-times" aria-hidden="true" onClick={() => this.setState({panelOpen: false, activeAperture: null}, () => this.checkValues())}></i>
          </div>
          }
          {this.state.selectGlazingName &&
          <div className="selected-glazing">
            <div className="glazing"><span></span>{this.state.selectGlazingName}</div>
            <i className="fa fa-times" aria-hidden="true" onClick={() => this.setState({panelOpen: false, selectGlazingId: null, selectGlazingName: null}, () => this.checkValues())}></i>
          </div>
          }
        </div>
        }
      </div>
    )
  }
}



export default ApertureGlazing;
